import { profileFromDto } from '@/app/entities/profile';

import { Credentials } from '../models';
import { CredentialsDto } from '../dto';

export function credentialsModelFromDto(dto: CredentialsDto): Credentials {
  return dto.user
    ? {
        token: dto.token.key,
        profile: profileFromDto(dto.user),
      }
    : {
        token: dto.token.key,
      };
}
